// Email campaigns rolled out to all companies 2026-08-17 (beta label kept on
// the marketing sidebar item). The gate function stays so the sidebar, the
// /marketing/campaigns route guards, and the wizard task visibility can be
// re-restricted from this single file if ever needed; the retired allowlist
// is preserved below for reference.
// export const CAMPAIGNS_BETA_COMPANY_IDS = [5, 7];

/**
 * Campaigns visibility gate. Ungated: every company sees the campaigns
 * surface (role permission gating still applies). To re-restrict, restore
 * the allowlist check.
 */
export function isCampaignsBetaCompany() {
  return true;
}
